import { sendNewPassword } from '@/calls/lostpassword';
import { ApiFatalError, ApiInvalidParamError } from '@/errors/errors';

const lostpassword = {
  namespaced: true,
  state: {
    requests: 0,
    form: null,
    error: false,
    badParams: false,
    fieldError: null,
    formError: null,
    successMessage: null,
    fields: {
      email: ''
    },
  },
  mutations: {
    setForm(state, el) {
      state.form = el;
    },
    updateField(state, { type, value }) {
      state.fields[type] = value;
    },
    setError(state, flag) {
      state.error = flag;
    },
    setBadParams(state, flag) {
      state.badParams = flag;
    },
    setFieldError(state, string) {
      state.fieldError = string;
    },
    setFormError(state, string) {
      state.formError = string;
    },
    setSuccessMessage(state, string) {
      state.successMessage = string;
    },
    increaseRequests(state) {
      state.requests += 1;
    },
    decreaseRequests(state) {
      state.requests -= 1;
    }
  },
  actions: {
    // eslint-disable-next-line
    async sendNewPassword({ state, commit, dispatch }, { loc }) {
        commit('increaseRequests');
        commit('setError', false);
        commit('setFieldError', null);
        commit('setSuccessMessage', null);
        try {
          const response = await sendNewPassword(new FormData(state.form), loc);
          commit('setError', false);
          commit('setBadParams', false);
          commit('setSuccessMessage', response.message);
        } catch (e) {
          if (e instanceof ApiInvalidParamError) {
            commit('setBadParams', true);
            commit('setFieldError', e.response.message);
          } else if (e instanceof ApiFatalError) {
            console.error('Lost password fatal error', e.response);
            commit('setError', true);
            commit('setFormError', e.response.message);
          } else {
            console.error('Lost password other fatal error', e.message);
            commit('setError', true);
            commit('setFormError', e.message);
          }
        }
        commit('decreaseRequests');
      },
  }
};

export default lostpassword;
